export const defaultValues = {
  firstName: null,
  secondName: null,
  surname: null,
  secondSurname: null,
  initRefundDate: null,
  endRefundDate: null,
  regional: null,
  gender: null,
};

export const headers = {
  initialHeaders: [
    {
      title: "Fecha de creación",
      field: "workStartDate",
      child: "workStartDate",
    },
    {
      title: "Nombre del empleado",
      field: "employee",
      child: "fullName",
    },
    {
      title: "Regional",
      field: "regional",
      child: "name",
    },
    {
      title: "Cargo",
      field: "cargo",
      child: null,
    },
    {
      title: "Tiempo de gestación",
      field: "contractTypeFormat",
      child: "contractType",
    },
  ],
  otherHeaders: [
    {
      title: "Tipo de identificación",
      field: "employee",
      child: "documentType",
    },
    {
      title: "Regional",
      field: "regional",
      child: null,
    },
    {
      title: "Cargo",
      field: "cargo",
      child: null,
    },

    {
      title: "Estado",
      field: "status",
      child: null,
    },
  ],
};

export const defaultSearchValues = {
  employeeSurname: null,
  initDate: null,
  regional: null,
  employeeName: null,
  endDate: null,
};